<!-- @format -->
<search-modal>
  <style>
    .modal__content_inner {
      max-height: 80vh;
      overflow-y: auto;
    }
    .wp60 {
      width: 60%;
    }
    .modal-error {
      margin: 4px 0px 16px 60%;
    }
  </style>

  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <h3 class="modal_heading margin-spacing-3_bottom">
          { props.caption }を検索する
        </h3>

        <h4
          if="{ props.groups.length === 0 }"
          class="heading-04 margin-spacing-2_top margin-spacing-2_bottom"
        >
          { props.caption }が見つかりませんでした。
        </h4>

        <div each="{ group in props.groups }">
          <h3 class="heading-03 margin-spacing-2_top margin-spacing-2_bottom">
            { group.name }
          </h3>
          <ul
            each="{ item in group.list }"
            class="checkbox_list { index ? 'margin-spacing-2_top' : '' }"
          >
            <li class="checkbox_list-item wp60">
              <input
                class="checkbox-input js-check_license-rank"
                type="checkbox"
                value="{ item.id }"
                checked="{ props.data.isChecked(item.id) }"
                id="{ props.modalId }_item_id_{ item.id }"
                onclick="{ props.onCheck }"
              />
              <label
                for="{ props.modalId }_item_id_{ item.id }"
                class="checkbox-parts"
              >
                { item.name }
              </label>
            </li>

            <li if="{ item.type=='select' }" class="checkbox_list-item03">
              <div class="sort-menu">
                <select
                  class="sort-list select_license-rank"
                  name="item_select_{item.id}"
                  disabled="{ !props.data.isChecked(item.id) }"
                  onchange="{ e => props.onSelect(e, item.id)}"
                >
                  <option each="{ rank in item.ranks }" value="{ rank.id }">
                    { rank.jname }
                  </option>
                </select>
              </div>
              <!--/.sort-menu-->
            </li>

            <li if="{ item.type=='score' }" class="checkbox_list-item03">
              <div class="sort-menu">
                <input
                  class="text_input"
                  type="text"
                  name="searchWord"
                  value="{ props.data.getMemo(item.id) }"
                  disabled="{ !props.data.isChecked(item.id) }"
                  oninput="{ e => props.onText(e, item.id)}"
                />
              </div>
              <div class="sort-menu">
                <p class="margin-spacing-2_left">点</p>
              </div>
              <!--/.sort-menu-->
            </li>

            <li if="{ props.errors[item.id] }" class="modal-error">
              <p class="alert_message note margin-spacing-2_left visible">
                { props.errors[item.id] }
              </p>
            </li>
          </ul>
        </div>

        <div class="wrap_button margin-spacing-2_top">
          <div
            class="button button-secondary-large button-border margin-spacing-1_right"
            type="button"
            value="登録しない"
            onclick="{ props.onClose }"
          >
            登録しない
          </div>
          <div
            class="button button-secondary-large"
            type="button"
            value="登録する"
            onclick="{ props.onSubmit }"
          >
            登録する
          </div>
        </div>
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>

  <script>
    import base from "./modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      },
      onBeforeShow() {
        for (const group of this.props.groups) {
          for (const item of group.list) {
            if (item.type == "select") {
              this.$(
                `select[name="item_select_${item.id}"]`
              ).value = this.props.data.getRankId(item.id);
            }
          }
        }
      },
    };
  </script>
</search-modal>
